export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8365.2fcd02e1.jpg";